import { render, staticRenderFns } from "./ViewAttachments.vue?vue&type=template&id=67e9131f&scoped=true"
import script from "./ViewAttachments.vue?vue&type=script&lang=js"
export * from "./ViewAttachments.vue?vue&type=script&lang=js"
import style0 from "./ViewAttachments.vue?vue&type=style&index=0&id=67e9131f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9131f",
  null
  
)

export default component.exports